module.exports = __webpack_public_path__ + "static/nobody-wants-to-read-your-sht-7275f33cf5690707316e8c76d7241d4c.jpg";